export class CustomerListFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/customer-list-filter.ts